export default __webpack_public_path__ + "static/media/gamepad-solid.b40a7a86.svg";